

type _extractFromTuple<
  TOrigRemaining extends any[] | readonly any[],
  TExtract extends any[] | readonly any[],
  TBuilt extends any[] = []
> =
  TOrigRemaining extends readonly [ infer FirstPart, ...infer Remaining ]
  ? (
    FirstPart extends TExtract[ number ]
    ? _extractFromTuple<readonly [ ...Remaining ], TExtract, [ ...TBuilt, FirstPart ]>
    : _extractFromTuple<readonly [ ...Remaining ], TExtract, [ ...TBuilt ]>
  ) :
  TOrigRemaining extends [ infer FirstPart, ...infer Remaining ]
  ? (
    FirstPart extends TExtract[ number ]
    ? _extractFromTuple<[ ...Remaining ], TExtract, [ ...TBuilt, FirstPart ]>
    : _extractFromTuple<[ ...Remaining ], TExtract, [ ...TBuilt ]>
  ) :
  TOrigRemaining extends readonly []
  ? readonly [ ...TBuilt ] :
  TOrigRemaining extends []
  ? TBuilt :
  TOrigRemaining extends readonly (infer U)[]
  ? readonly Extract<U, TExtract[ number ]>[] :
  TOrigRemaining extends (infer U)[]
  ? Extract<U, TExtract[ number ]>[]
  : never;


export type ExtractFromTuple<T extends [ ...any[] ] | readonly [ ...any[] ], TExtract extends [ ...any[] ] | readonly [ ...any[] ]> = _extractFromTuple<T, TExtract>;

export function extractFromTuple<
  const T extends any[] | readonly any[],
  const TExtract extends (T[ number ])[] | readonly (T[ number ])[] | any[] | readonly any[]
>(arr: T, ...allowedValues: TExtract): ExtractFromTuple<T, TExtract> {
  const result = arr.filter((a) => allowedValues.includes(a));
  if (Object.isFrozen(arr)){
    Object.freeze(result);
  }
  return result as ExtractFromTuple<T, TExtract>;
}